import styled from 'styled-components';

export const DetailsForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`;

export const Notice = styled.p`
  margin: 0;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 13px;
  background: ${({ theme }) => theme.colors.secondaryContainer};
  color: ${({ theme }) => theme.colors.onSecondaryContainer};
`;

export const DetailsFooter = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  margin: 0 -20px -20px;
  padding: 12px 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  background: ${({ theme }) => theme.colors.surface};
`;
